import React from 'react';

// Backgrounds + cut-out overlays for each hero slide. Parcel content-hashes
// every format independently, so each variant needs its own explicit `url:`
// import (see the OptimizedImage helper).
import greaterChinaBg from 'url:../../assets-optimized/redesign/homPageCarousel/hero_first_slide.png';
import greaterChinaBgWebp from 'url:../../assets-optimized/redesign/homPageCarousel/hero_first_slide.webp';
import greaterChinaBgAvif from 'url:../../assets-optimized/redesign/homPageCarousel/hero_first_slide.avif';
import greaterChinaOverlay from 'url:../../assets-optimized/redesign/homPageCarousel/hero_first_slide_overlay.png';
import greaterChinaOverlayWebp from 'url:../../assets-optimized/redesign/homPageCarousel/hero_first_slide_overlay.webp';
import greaterChinaOverlayAvif from 'url:../../assets-optimized/redesign/homPageCarousel/hero_first_slide_overlay.avif';
import greaterChinaBgMobile from 'url:../../assets-optimized/redesign/homPageCarousel/hero_first_slide_mobile.jpg';
import greaterChinaBgMobileWebp from 'url:../../assets-optimized/redesign/homPageCarousel/hero_first_slide_mobile.webp';
import greaterChinaBgMobileAvif from 'url:../../assets-optimized/redesign/homPageCarousel/hero_first_slide_mobile.avif';
import psychologyBg from 'url:../../assets-optimized/redesign/homPageCarousel/hero_second_slide.jpg';
import psychologyBgWebp from 'url:../../assets-optimized/redesign/homPageCarousel/hero_second_slide.webp';
import psychologyBgAvif from 'url:../../assets-optimized/redesign/homPageCarousel/hero_second_slide.avif';
import psychologyOverlay from 'url:../../assets-optimized/redesign/homPageCarousel/hero_second_slide_overlay.png';
import psychologyOverlayWebp from 'url:../../assets-optimized/redesign/homPageCarousel/hero_second_slide_overlay.webp';
import psychologyOverlayAvif from 'url:../../assets-optimized/redesign/homPageCarousel/hero_second_slide_overlay.avif';
import journeyBg from 'url:../../assets-optimized/redesign/homPageCarousel/hero_third_slide.jpg';
import journeyBgWebp from 'url:../../assets-optimized/redesign/homPageCarousel/hero_third_slide.webp';
import journeyBgAvif from 'url:../../assets-optimized/redesign/homPageCarousel/hero_third_slide.avif';
import journeyOverlay from 'url:../../assets-optimized/redesign/homPageCarousel/hero_third_slide_overlay.png';
import journeyOverlayWebp from 'url:../../assets-optimized/redesign/homPageCarousel/hero_third_slide_overlay.webp';
import journeyOverlayAvif from 'url:../../assets-optimized/redesign/homPageCarousel/hero_third_slide_overlay.avif';

// Darkening overlay applied over each slide's photo (behind the panels).
const GRADIENT_OVERLAY =
  'linear-gradient(0deg, rgba(0, 0, 0, 0.06), rgba(0, 0, 0, 0.06)), ' +
  'linear-gradient(184.89deg, rgba(0, 0, 0, 0.2) 33.28%, rgba(102, 102, 102, 0.086) 96.06%)';

const MembersIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 22 22' fill='none'>
    <path
      d='M8.03 11.55c-2.32 0-6.93 1.05-6.93 3.15v1.575h13.86V14.7c0-2.097-4.614-3.15-6.93-3.15Zm-4.614 2.925c.832-.522 2.842-1.125 4.614-1.125 1.772 0 3.781.603 4.613 1.125H3.416ZM8.03 9.975c1.91 0 3.465-1.413 3.465-3.15S9.94 3.675 8.03 3.675c-1.911 0-3.465 1.413-3.465 3.15s1.554 3.15 3.465 3.15Zm0-4.5c.822 0 1.485.603 1.485 1.35S8.85 8.175 8.03 8.175c-.822 0-1.485-.603-1.485-1.35s.663-1.35 1.485-1.35Zm6.97 6.129c1.148.756 1.94 1.764 1.94 3.096v1.575h3.96V14.7c0-1.818-3.465-2.853-5.9-3.096ZM13.97 9.975c1.91 0 3.465-1.413 3.465-3.15s-1.554-3.15-3.465-3.15c-.535 0-1.03.117-1.485.315.624.801.99 1.782.99 2.835 0 1.053-.366 2.034-.99 2.835.455.198.95.315 1.485.315Z'
      fill='#fff'
    />
  </svg>
);

const BedIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 22 22' fill='none'>
    <path
      d='M18.333 10.083V7.333A1.836 1.836 0 0 0 16.5 5.5H5.5a1.836 1.836 0 0 0-1.833 1.833v2.75C2.706 10.358 2 11.22 2 12.265v3.568h1.1v1.084h1.1v-1.084h13.2v1.084h1.1v-1.084H19.8v-3.568c0-1.045-.706-1.907-1.467-2.182ZM9.167 10.083H5.5V8.25h3.667v1.833Zm7.333 0h-3.667V8.25H16.5v1.833Z'
      fill='#fff'
    />
  </svg>
);

export const slides = [
  {
    id: 'psychology-of-travel',
    bg: { avif: psychologyBgAvif, webp: psychologyBgWebp, fallback: psychologyBg },
    overlay: {
      avif: psychologyOverlayAvif,
      webp: psychologyOverlayWebp,
      fallback: psychologyOverlay,
    },
    overlayBg: GRADIENT_OVERLAY,
    sideBg: 'linear-gradient(180deg, rgba(0, 0, 0, 0.26) 12.42%, rgba(217, 217, 217, 0) 27.15%)',
    badge: { label: 'Room Nights Booked', value: '450M+', icon: <BedIcon /> },
    title: (
      <>
        Tap
        <br className='desktop-only' /> into the
        <br className='desktop-only' /> Psychology
        <br className='desktop-only' /> of Travel
      </>
    ),
    sideText:
      'Download the latest research on the psychology of travel and the consumer mindset brought to you by Marriott Media and Kinective Media by United Airlines.',
    cta: { label: 'GET THE REPORT', action: 'report' },
  },
  {
    id: 'greater-china',
    bg: { avif: greaterChinaBgAvif, webp: greaterChinaBgWebp, fallback: greaterChinaBg },
    bgMobile: {
      avif: greaterChinaBgMobileAvif,
      webp: greaterChinaBgMobileWebp,
      fallback: greaterChinaBgMobile,
    },
    overlay: {
      avif: greaterChinaOverlayAvif,
      webp: greaterChinaOverlayWebp,
      fallback: greaterChinaOverlay,
    },
    overlayBg: 'rgba(0, 0, 0, 0.13)',
    badge: { label: 'Marriott Bonvoy members', value: '271M+', icon: <MembersIcon /> },
    title: (
      <>
        Marriott
        <br className='desktop-only' /> Media
        <br className='desktop-only' /> Launches in
        <br className='desktop-only' /> Greater China
      </>
    ),
    sideText: 'Redefining brand to guest engagement through travel-powered media at global scale.',
    cta: { label: 'READ THE PRESS RELEASE', href: '/#/press-releases/greater-china-launch' },
  },
  {
    id: 'every-journey',
    bg: { avif: journeyBgAvif, webp: journeyBgWebp, fallback: journeyBg },
    overlay: {
      avif: journeyOverlayAvif,
      webp: journeyOverlayWebp,
      fallback: journeyOverlay,
    },
    overlayBg: GRADIENT_OVERLAY,
    sideBg: 'linear-gradient(180deg, rgba(0, 0, 0, 0.4) 25.96%, rgba(102, 102, 102, 0) 35.58%)',
    badge: { label: 'Targetable Audience Attributes', value: '500+', icon: <MembersIcon /> },
    title: (
      <>
        Be a Part of
        <br className='desktop-only' /> Every Journey
        <br className='desktop-only' /> and the Life
        <br className='desktop-only' /> it Inspires
      </>
    ),
    sideText:
      'We pair privacy-safe Marriott Bonvoy data with decades of knowing how our audiences move through the world.',
    cta: { label: 'LET’S PARTNER', action: 'contact' },
  },
];
